module.exports = __webpack_public_path__ + "images/mobile/home_devices-217bc781807768f183120c275460ff74.png";